import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import '../css/pagination.scss';

const PaginationListView = ({ page, perPage, onChangePage, total_data, data }) => {
  function pageList() {
    let pages = [];
    var numberOfPages = Math.floor((total_data + perPage - 1) / perPage);
    for (let i = 1; i <= numberOfPages; i++) {
      pages.push(i);
    }
    return pages;
  }

  function disablePrev() {
    if (page <= 1) {
      return true;
    } else {
      return false;
    }
  }

  function disableNext() {
    if (pageList().length === page) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      {data && data.length ? (
        <nav aria-label="..." className="nav-pagination">
          <ul className="list-pagination">
            <li className="pagination-item">
              <button className="pagination-link" disabled={disablePrev()} onClick={() => onChangePage(page - 1)}>
                <FaChevronLeft />
              </button>
            </li>
            {pageList().map((pageItem) => {
              return (
                <li className="pagination-item">
                  <button
                    className={`pagination-link ${page === pageItem ? `active` : ``} `}
                    onClick={() => onChangePage(pageItem)}
                  >
                    {pageItem}
                  </button>
                </li>
              );
            })}
            <li className="pagination-item">
              <button className="pagination-link" disabled={disableNext()} onClick={() => onChangePage(page + 1)}>
                <FaChevronRight />
              </button>
            </li>
          </ul>
        </nav>
      ) : (
        <div className="bg-white p-4 d-flex flex-row align-items-center justify-content-center">
          <p className="m-0">There are no records to display</p>
        </div>
      )}
    </>
  );
};

export default PaginationListView;
